import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
    modelValue: _ctx.currentText,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentText) = $event)),
    onPaste: _ctx.onPaste,
    onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('keyup', $event))),
    onKeypress: _ctx.onKey,
    "error-messages": _ctx.errorMessage,
    inputmode: _ctx.type === 'decimal'? 'decimal' : 'numeric'
  }, _ctx.fieldProps), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(scope || {})))
        ])
      }
    })
  ]), 1040, ["modelValue", "onPaste", "onKeypress", "error-messages", "inputmode"]))
}